<template>
    <div class="cart-shop-header" :class="{ 'active': shopCartShow }">
        <div class="container text-bat">
            <div class="mt-4 d-flex flex-row-reverse cursor-pointer" @click="toggleShopCart">
                <img lass="img-menu-fixed" src="/img/icons/boton-cerrar-cart.svg" alt="">
            </div>
            <h4 class="my-3 pb-3 text-title-bat text-indigo-darkness">
                Carrito de canje
            </h4>
            <div v-if="products_cart.length > 0">
                <div v-for="product_cart in products_cart" >
                    <div class="row mb-4">
                        <div class="col-4 d-flex justify-content-center align-items-center">
                            <img v-if="product_cart.PRODUCT_IMAGE" class="img-fluid img-cart-header" :src="media_netcommerce + product_cart.PRODUCT_IMAGE.replace('~/', '')" :alt="product_cart.NAME">
                            <img v-else src="/img/default_image.png" :alt="product_cart.NAME" class="img-fluid img-cart-header">
                        </div>
                        <div class="col-8">
                            <p class="fs-6 text-title-bat lh-1">
                                {{ product_cart.NAME }}
                            </p>
                            <span class="fs-6 d-flex flex-row justify-content-start">
                                <strong class="me-2">
                                    {{ (product_cart.POINTS_UNIT_VALUE + product_cart.POINTS_UNIT_SHIPPING) * product_cart.QUANTITY }} puntos
                                </strong>
                                {{ product_cart.QUANTITY }} Unidades
                            </span>
                        </div>
                        <div class="col-2 d-flex justify-content-center align-items-start cursor-pointer d-none">
                            <img class="img-menu-fixed" src="/img-version2/icons/trash.svg" alt="">
                        </div>
                    </div>
                </div>
                <div class="w-100 d-flex justify-content-center align-items-center text-center">
                    <a id="btn-go-cart-header" title="Botón ir al carrito" class="w-100 btnBlue text-title-bat text-decoration-none" href="/show-shopping-cart">
                        Ir a canjear
                    </a>
                </div>
            </div>
            <div v-else>
                <h6 class="text-title-bat my-4 text-center">Aún no has agregado productos al carrito</h6>
                <div class="w-100 d-flex justify-content-center align-items-center text-center">
                    <a id="btn-go-redeem-header" title="Botón ir a canjear" class="w-100 btnBlue text-title-bat text-decoration-none" href="/catalogo">
                        Ir a canjear ahora
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            shopCartShow: {
                type: Boolean,
                default: false,
            },
            media_netcommerce:{
                default: "",
            },
            products_cart:{
                default: [],
            },
        },
        data() {
            return {
            }
        },
        methods: {
            toggleShopCart() {
                this.$emit('toggleShopCart');
            },
        }
    }
</script>
